export default function MiniRatingBars({ recentGames = [] }) {
  const MIN = 30;

  function getBarColor(rating) {
    if (rating >= 80) return "bar-elite";
    if (rating >= 65) return "bar-high";
    if (rating >= 50) return "bar-mid";
    if (rating >= 40) return "bar-average";
    return "bar-low";
  }

  function getSolidColor(rating) {
    if (rating >= 80) return "linear-gradient(53.32deg, rgb(234,227,218), rgb(191,230,239), rgb(225,227,245), rgb(230,186,221))";
    if (rating >= 65) return "rgba(0, 243, 235, 0.8)";
    if (rating >= 50) return "rgba(37, 237, 54, 0.8)";
    if (rating >= 40) return "#ff7e34";
    return "rgba(239, 68, 68, 0.8)";
  }

  if (!recentGames.length) return null;

  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: "2px", height: "30px", padding: "4px", borderRadius: "4px", width: "min-content" }}>
      {[...recentGames].reverse().map((s, i) => {
        const heightPct = Math.max(((s.rating - MIN) / (100 - MIN)) * 100, 5);
        return (
          <div key={i} style={{ width: "4px", height: "100%", display: "flex", alignItems: "flex-end" }}>
            <div
              className={`bar ${getBarColor(s.rating)}`}
              style={{ width: "100%", height: `${heightPct}%`, borderRadius: "1px 1px 0 0", background: getSolidColor(s.rating), mask: "none" }}
            />
          </div>
        );
      })}
    </div>
  );
}